export class ClosingInfoApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLoanClosingInfo({ loanId }) {
    return this.#http.get(`/loan/${loanId}/closing-info`);
  }
}
